import { css } from '@emotion/react';
import { useContext, useRef } from 'react';
import { useAppDispatch } from 'redux/store';
import MentoringProgramContext, { MentoringProgramHomeUIContext } from 'athena/components/mentoring-program/context';
import { RecruitmentApplication } from 'redux/schemas/models/mentoring-program-recruitments';
import type { RowProps } from 'shared/components/nv-table';
import NvTableCells from 'shared/components/nv-table/nv-table-cells';
import { gray7 } from 'styles/global_defaults/colors';
import CheckboxCell from './checkbox-cell';
import NameCell from './name-cell';
import DateSubmittedCell from './date-submitted-cell';
import AddButtonCell from './add-button-cell';
import { ColumnID } from './types';
import { config } from '@config/pendo.config.json';


const cellMap = {
  [ColumnID.CHECKBOX]: CheckboxCell,
  [ColumnID.NAME]: NameCell,
  [ColumnID.DATE_SUBMITTED]: DateSubmittedCell,
  [ColumnID.ADD_BUTTON]: AddButtonCell,
};

const styles = css`
  height: 70px;

  &:hover {
    background-color: ${gray7};

    .add-individual-target {
      opacity: 1;
    }
  }
`;

const RecruitmentRow = ({
  row,
  className,
  getCellStyle,
}: RowProps<RecruitmentApplication>) => {
  const { original } = row || {};
  const { id } = original || {};

  return (
    <div
      css={styles}
      className={`align-content-center border-bottom border-gray-6 ${className}`}
      data-qa={`${config.pendo.athena.mentorshipProgram.recruitment.recruitmentApplicationRow}_${id}`}
    >
      <NvTableCells row={row} getCellStyle={getCellStyle} cellMap={cellMap} />
    </div>
  );
};

export default RecruitmentRow;
